

































import { helpers, required, requiredIf, maxLength } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import { mapGetters } from 'vuex';

export default {
	name: 'MakeOfferFactors',

	setup() {
		const form = reactive({
			qualification: null,
			experience: null,
			other_factors: null,
		});

		const edit = ref(false);

		const loading = ref(false);

		return { form, edit, loading };
	},

	props: {
		job_application_uuid: {
			type: String,
			required: false,
			default: null,
		},
	},
	computed: {
		...mapGetters('jobs/single', {
			job: 'getSingleJob',
		}),

		...mapGetters('applications', {
			candidate: 'getApplicant',
		}),

		...mapGetters('offerModule', {
			factors: 'getFactors',
		}),

		qualifications() {
			return this.candidate.qualifications.length > 0
				? this.candidate.qualifications.map((item) =>
						item.degree ? item.degree.name : item.qualification_name ? item.qualification_name : null,
				  )
				: [];
		},
		experiences() {
			return this.candidate.work_experiences.length > 0 ? this.candidate.work_experiences.map((item) => item.job_title) : [];
		},

		jobFactors() {
			return JSON.parse(JSON.stringify(this.factors));
		},
	},

	mounted() {
		this.populateData();
	},

	destroyed() {
		this.updateFactors();
	},

	methods: {
		async submit() {
			this.loading = true;
			this.updateFactors();
			await this.$store
				.dispatch('offerModule/createJobOffer', {
					uuid: this.job_application_uuid,
					data: {
						job_uuid: this.job.uuid,
						candidate: this.candidate,
					},
				})
				.then((res) => {
					console.log(res);
					this.trackJobOfferSent(res);
					this.loading = false;
					this.$toast.show({
						type: 'success',
						message: 'Offer has been sent to candidate.',
					});
					this.$emit('close');
				})
				.catch((err) => {
					this.loading = false;
					this.$toast.show({
						type: 'danger',
						message: err.response.data.message,
					});
				});
		},
		cancel() {
			this.$emit('close');
		},

		populateData() {
			this.form.qualification = this.jobFactors?.qualification || null;
			this.form.experience = this.jobFactors?.experience || null;
			this.form.other_factors = this.jobFactors?.other_factors || null;

			this.updateFactors();
		},

		updateFactors() {
			this.$store.dispatch('offerModule/updateFactors', {
				qualification: this.form.qualification,
				experience: this.form.experience,
				other_factors: this.form.other_factors,
			});
		},
		trackJobOfferSent(res) {
			this.$gtm.push({
				event: 'jobOfferSent',
				user_id: this.$auth.user.uuid,
				company_id: this.$auth.user.company.uuid,
				candidate_id: this.candidate.uuid,
				job_id: this.job.uuid,
				job_offer_id: res.uuid,
			});
		},
	},
};
